// extracted by mini-css-extract-plugin
export var actionButton = "_el-0";
export var fileInput = "_el-2";
export var paperclip = "_el-1";